export const setProduct = function ({commit}, product) {
    commit('SETPRODUCT', product);
};

export const incrementStep = function ({commit, state}) {
    commit('INCREMENTSTEP');
};

export const decrementStep = function ({commit, state}) {
    commit('DECREMENTSTEP');
};

import SweetScroll from 'sweet-scroll';
const sweetScroll = new SweetScroll({
    duration:600,
    easing:'easeInOutCirc',
});

export const setStep = function ({commit, state}, stepNumber){
    sweetScroll.to('top:0');
    commit('SETSTEP', stepNumber)
};

export const setDetails = function ({commit, state}, details) {
    commit('SETDETAILS', details);
};

export const setInformation = function ({commit, state}, information) {
    commit('SETINFORMATION', information);
};

export const setCardToken = function ({commit, state}, token) {
    commit('SETCARDTOKEN', token);
};

export const setInvoice = function({commit, state}, invoice) {
    commit('SETINVOICE', invoice);
};

export const setLoading = function ({commit, state}, isLoading) {
    commit('SETLOADING', isLoading);
};

export const setCardError = function ({commit, state}, cardError) {
    commit('SETCARDERROR', cardError);
};

export const setClientSecret = function({commit, state}, clientSecret){
    commit('SETCLIENTSECRET', clientSecret);
}

export const setInvoiceLink = function({commit, state}, link){
    commit('SETINVOICELINK', link);
}
